export const headerTitle = {
	id: 'assetgroup.detail.updatejob.title',
	defaultValue: 'Firmware Update'
};
export const latestExecutionDateLabel = {
	id: 'updatejobs.latestExecutionDate',
	defaultValue: 'Latest execution date'
};
export const latestExecutionDateInfo = {
	id: 'updatejobs.tenantscheduler.latestExecutionDateInfo',
	defaultValue:
		'This is the latest date at which the update needs to be carried out. You can schedule the actual execution date for any date between now and the latest execution date.'
};
export const actualExecutionDateLabel = {
	id: 'updatejobs.actualExecutionDate',
	defaultValue: 'Actual execution date'
};
export const actualExecutionDateInfoWorkspace = {
	id: 'updatejobs.tenantscheduler.actualExecutionDateInfoWorkspace',
	defaultValue:
		'The actual execution date is when the update will actually be carried out. You can schedule the update for any date between now and the latest execution date.'
};
export const actualExecutionDateInfoInventory = {
	id: 'updatejobs.tenantscheduler.actualExecutionDateInfoInventory',
	defaultValue:
		'The actual execution date is when the update will actually be carried out. Setting the actual execution date in an inventory asset group will override the actual execution dates in its workspaces.'
};
export const scheduleButtonWorkspace = {
	id: 'updatejobs.tenantscheduler.scheduleButtonWorkspace',
	defaultValue: 'Change actual execution date'
};
export const scheduleButtonInventory = {
	id: 'updatejobs.tenantscheduler.scheduleButtonInventory',
	defaultValue: 'Change actual execution date for all assets'
};
export const scheduleSaveButtonWorkspace = {
	id: 'updatejobs.tenantscheduler.scheduleSaveButtonWorkspace',
	defaultValue: 'Save actual execution date'
};
export const scheduleSaveButtonInventory = {
	id: 'updatejobs.tenantscheduler.scheduleSaveButtonInventory',
	defaultValue: 'Save actual execution date for all assets'
};
export const cancelButton = {
	id: 'updatejobs.tenantscheduler.cancelButton',
	defaultValue: 'Cancel'
};
export const workspaceExecutionInfo = {
	id: 'updatejobs.tenantscheduler.workspaceExecutionInfo',
	defaultValue: 'Only assets in this workspace will be affected by a change of the actual execution date.'
};
